import {DateRangePickers} from './date-range-pickers';

interface Context {
    perQuantityAddons: Record<string, boolean>;
    dateRangeAddons: DateRangePickers;
    [key: string]: any;
}

const context: Context = {
    perQuantityAddons: {},
    dateRangeAddons: new DateRangePickers(),
};

export {context};
